export default "1fc453569359125a.ttf"